import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import style from './style';
import { globalStyles, noop } from "shared/constants";
import { useState } from "react";
import LinearProgress from '@mui/material/LinearProgress';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ErrorModal from 'shared/components/error-modal';

const UploadView = ({
  syncErrors = [],
  syncingProgress = 0,
  isSyncing =  false,
  isSyncCompleted =  false,
  errorModal = {},
  handleFileChanges = noop,
  handleErrorModalClose = noop,
  onContinue = noop,
}) => {

  return (
    <>
      <Paper elevation={0} sx={style.paper}>
        <Box sx={{...globalStyles.display.flex, ...globalStyles.flex.justify.between}}>
          <Box>
            <Typography variant="body1" sx={style.title}>File Upload</Typography>
            <Typography variant="body2">4. Upload your edited file.</Typography>
          </Box>
          <Box>
            {!(syncingProgress < 100 || syncErrors.length) && (
              <Button
                sx={{ ...globalStyles.margin(2, 'Right')}}
                variant='outlined'
                color='primary'
                onClick={onContinue}
              >
                Continue
              </Button>
            )}
            <Button
              variant='contained'
              color='primary'
              component='label'
              htmlFor='erl-file'
              startIcon={<CloudUploadIcon />}
              disabled={!syncErrors.length && isSyncCompleted}
            >
              Upload File
            </Button>
            <Box sx={{ ...globalStyles.display.none }}>
              <input
                id='erl-file'
                type='file'
                accept={`.xls, .xlsx`}
                onChange={handleFileChanges}
                onClick={evt => (evt.currentTarget.value = '')}
              />
            </Box>
          </Box>
        </Box>
        {(isSyncing || isSyncCompleted) && (
          <Box>
            <LinearProgress
              variant='determinate'
              value={syncingProgress}
              sx={[
                globalStyles.margin(5, 'Top'),
                globalStyles.width[100],
                style.progressBar,
                {
                  '& .MuiLinearProgress-barColorPrimary	': {
                    ...(!!syncErrors.length ? globalStyles.background.color.error.main : globalStyles.background.color.primary.main)
                  },
                }
              ]}
            />
          </Box>
        )}
      </Paper>
      {!!syncErrors.length && (
        <Accordion
          sx={{...style.accordionPaper }}
          component={Paper}
          elevation={0}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon color="error" />}
            sx={{
              ...globalStyles.margin(2, 'Top'),
              ...globalStyles.padding(4, 'Left'),
              ...globalStyles.padding(4, 'Right'),
              ...globalStyles.flex.justify.start,
              ...globalStyles.background.color.white.main
            }}
          >
            <Typography
              color="error"
              variant="body2"
              sx={{
                ...globalStyles.text.weight.bold,
                ...globalStyles.margin(1, "Right"),
              }}
            >
              ERRORS DETECTED
            </Typography>
          </AccordionSummary>
          <AccordionDetails
            sx={{
              ...globalStyles.padding(7, 'Left'),
              ...globalStyles.padding(7, 'Right'),
            }}
          >
            <Box
              sx={{
                ...globalStyles.display.flex,
                ...globalStyles.flex.justify.between,
              }}
            >
              <Typography variant="body2" sx={{ ...globalStyles.text.weight.bold }}>Errors</Typography>
              <Typography variant="body2" sx={{ ...globalStyles.text.weight.bold }}>Line</Typography>
            </Box>
            {syncErrors.map(({ message, rowNumber }) => (
              <Box
                sx={{
                  ...globalStyles.display.flex,
                  ...globalStyles.flex.justify.between
                }}
              >
                <Typography variant="body2" color="error">{message}</Typography>
                <Typography variant="body2" color="error">{rowNumber}</Typography>
              </Box>
            ))}
          </AccordionDetails>
        </Accordion>
      )}
      {errorModal.open && (
        <ErrorModal
          showModel={errorModal.open}
          headers={[]}
          errorBody={errorModal.errorBody || []}
          onClose={handleErrorModalClose}
          title='Oops! Encountered an error. Please read the message below for details.'
          errorMessage={errorModal.errorMessage}
        />
      )}
    </>
  );
};

export default UploadView;